(function ($) {

    // Back to top link
    var bttLink = $(".btt-arrow");

    bttLink.click(function () {
        $("html, body").animate({ scrollTop: 0 }, 1000);
        return false;
    });

})(window.jQuery);